'use strict';
var _ = require('lodash');
var Mapper = require('./Mapper.js');
var Products = require('./Products.js');
var Constants = require('../constants/YourDetailsConstants');
var ApplicationConstants = require('../constants/ApplicationConstants');
var Values = Constants.Values;
var FormKeys = ApplicationConstants.FormKeys;

module.exports = {

    getCountryValue: function (obj) {
        var value = '';
        if (obj.length > 0) {
            value = obj[0].label;
        }
        return value;
    },
    getCountryCode: function (obj) {
        var value = obj;
        if (obj instanceof Array && obj.length > 0) {
            value = obj[0].value;
        }
        return value.trim();
    },
    expandTitlesOnRetrieve: function (titleList, title) {
        if (title !== undefined && titleList.length > 0) {
            var obj = _.find(titleList, { id: parseInt(title) });
            if (obj && obj.isHidden) {
                return true;
            }
        }
        return false;
    },
    createNewInvestor: function (index, investorType, isCorporate) {
        var trusteeType;
        if (investorType === Constants.InvestorType.TRUSTEE){
            if (isCorporate){
                trusteeType = Constants.TrusteeType.CORPORATE;
            }
            else{
                trusteeType = Constants.TrusteeType.INDIVIDUAL;
            }
        }
        var investor = {
            id: index,
            oin: 0,
            gender: undefined,
            title: undefined,
            givenName: undefined,
            lastName: undefined,
            dateOfBirth: undefined,
            addressInfo: _.clone(Constants.Properties.AddressInfo),
            mobileNumber: undefined,
            homeNumber: undefined,
            workNumber: undefined,
            emailAddress: undefined,
            tfnNumber: undefined,
            tfnExemptionReason: undefined,
            hasTfnExemption: '',
            tfnConsentFlag: undefined,
            tfnWithConsent: undefined,
            isAustralianResident: undefined,
            countryOfResidence: undefined,
            isOtherCountryTaxResident: undefined,
            otherCountryTaxResidence1: undefined,
            otherCountryTaxResidence2: undefined,
            otherCountryTaxResidence3: undefined,
            isCitizenOfOtherCountry: undefined,
            citizenship1: undefined,
            citizenship2: undefined,
            tin1: undefined,
            tin2: undefined,
            tin3: undefined,
            tinExemptionReason1: undefined,
            tinExemptionReason2: undefined,
            tinExemptionReason3: undefined,
            occupation: undefined,
            abn: undefined,
            corporateTrustee: undefined,
            trusteeType: trusteeType,
            sectionName: (investorType === Constants.InvestorType.INVESTOR) ? 'ydInvestor' : 'ydTrustee',
            titleReadonly: undefined,
            givenNameReadonly: undefined,
            lastNameReadonly: undefined,
            genderReadonly: undefined,
            dateOfBirthReadonly: undefined,
            occupationReadonly: undefined,
            countryOfResidenceReadonly: undefined,
            tfnNumberReadonly: undefined,
            mobileNumberReadonly: undefined,
            homeNumberReadonly: undefined,
            workNumberReadonly: undefined,
            emailAddressReadonly: undefined,
            isAustralianResidentReadonly: undefined,
            isOtherCountryTaxResidentReadonly: undefined,
            otherCountryTaxResidenceReadonly: undefined,
            isCitizenOfOtherCountryReadonly: undefined,
            isPowerOfAttorney: false,
            citizenship1Readonly: undefined,
            citizenship2Readonly: undefined,
            businessNameReadonly: undefined,
            abnReadonly: undefined,
            isAustralianTaxResident: undefined,
            sourceOfFund: undefined,
            sourceOfWealth: undefined,
            otherSourceOfFund: undefined,
            otherSourceOfWealth: undefined,
            sourceOfFundDescription: undefined,
            sourceOfWealthDescription: undefined
        };

        if (index > 0) {
            delete investor.isPowerOfAttorney;
        }

        return investor;
    },
    postAddressInfoSave: function (addressInfo, fieldId){
        switch(fieldId){
            case 'isResPostalAdd':
                Mapper.objectMerger(addressInfo, {
                    definePostalAddressLine: '',
                    postal: '',
                    postalCountry: '',
                    postalAddress1: '',
                    postalAddress2: '',
                    postalCityStatePostCode: '',
                    postalAusState: '',
                    postalPostCode: ''
                });
                break;
            case 'resCountry':
                Mapper.objectMerger(addressInfo, {cityStatePostCode: '', resAusState: '', postCode: ''});
                break;
            case 'postalCountry':
                Mapper.objectMerger(addressInfo, {postalCityStatePostCode: '', postalAusState: '', postalPostCode: ''});
                break;
            case 'defineAddressLine':
                Mapper.objectMerger(addressInfo, {
                    residential: '',
                    resCountry: Values.COUNTRY_AUSTRALIA,
                    address1: '',
                    address2: '',
                    cityStatePostCode: '',
                    resAusState: '',
                    postCode: '',
                    isResPostalAdd: ''
                });
                break;
            case 'definePostalAddressLine':
                Mapper.objectMerger(addressInfo, {
                    postal: '',
                    postalCountry: Values.COUNTRY_AUSTRALIA,
                    postalAddress1: '',
                    postalAddress2: '',
                    postalCityStatePostCode: '',
                    postalAusState: '',
                    postalPostCode: ''
                });
                break;
            case 'postalAddress1':
                Mapper.objectMerger(addressInfo, {
                    postal: '',
                    isPostalAddressFound: false
                });
                break;
            case 'address1':
                Mapper.objectMerger(addressInfo, {
                    residential: '',
                    isResAddressFound: false
                });
                break;
            default:
            break;
        }
    },
    //Returns the index + 1 of the specified field that will be inserted with new items on the list
    getIndexForInsert: function (rule, field, list){
        var index;
        _.forEach(rule, function(value, key){
            var newIndex = _.findIndex(list, function(o){ return o.id.indexOf(key) > -1 });
            index = (newIndex !== -1) ? newIndex : index;
            if (key === field){
                return false;
            }
        });
        return (index === undefined) ? 0 : ++index;
    },
    removeValidation: function (errors, listOfIds, Validators){
        _.forEach(listOfIds, function(id){
            Validators.clearErrorListForField(errors, id);
        });
    },
    addAddressNotFoundValidation: function(addressInfo, addressRules){
        if (addressInfo.defineAddressLine === ApplicationConstants.YesNoValues.YES) {
            delete addressRules.residential;
        } else {
            if (addressInfo.residential && !addressInfo.isResAddressFound) {
                addressRules.residential = 'addressNotFound';
            }
        }

        if (addressInfo.definePostalAddressLine === ApplicationConstants.YesNoValues.YES) {
            delete addressRules.postal;
        } else {
            if (addressInfo.postal && !addressInfo.isPostalAddressFound) {
                addressRules.postal = 'addressNotFound';
            }
        }
    },
    isIndividualApplication: function(productId, accountType) {
        if (!productId) {
            return true;
        }
        if (Products.isSuper(productId) || Products.isPension(productId)) {
            return true;
        } else {
            var formKey = Products.getFormKey(accountType, productId);
            switch (formKey) {
                case FormKeys.INDIVIDUAL_INVESTMENT:
                case FormKeys.INDIVIDUAL_CHALLENGER:
                case FormKeys.INDIVIDUAL_COMMINSURE:
                case FormKeys.JOINT_INVESTMENT:
                case FormKeys.JOINT_CHALLENGER:
                case FormKeys.JOINT_COMMINSURE:
                    return true;
                default:
                    return false;
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/YourDetailsHelpers.js